import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Footer.module.css";

import productoIcon from "../assets/exercise.png";
import calendarioIcon from "../assets/calendar.png";
import estadisticasIcon from "../assets/stats.png";
import usuarioIcon from "../assets/person.png";

type TabKey = "producto" | "calendario" | "estadisticas" | "usuario";

const Footer: React.FC = () => {
  const [active, setActive] = useState<TabKey>("producto");
  const navigate = useNavigate();

  const tabs: { key: TabKey; label: string; route: string; icon: string }[] = [
    { key: "producto", label: "Producto", route: "/product", icon: productoIcon },
    { key: "calendario", label: "Calendario", route: "/calendar", icon: calendarioIcon },
    { key: "estadisticas", label: "HP", route: "/statistics", icon: estadisticasIcon },
    { key: "usuario", label: "Usuario", route: "/user", icon: usuarioIcon },
  ];

  const handleTabClick = (key: TabKey, route: string) => {
    setActive(key);
    navigate(route);
  };

  return (
    <div className={styles.footerWrapper}>
      {/* Barra de tabs */}
      <footer className={styles.footer}>
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className={`${styles.tab} ${active === tab.key ? styles.active : ""}`}
            onClick={() => handleTabClick(tab.key, tab.route)}
            data-tour={`tab-${tab.key}`}
          >
            <img src={tab.icon} alt={tab.label} className={styles.icon} />
            <span>{tab.label}</span>
          </div>
        ))}
      </footer>
    </div>
  );
};

export default Footer;
